import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals, map, pipe, uniqBy, prop } from "ramda";
import { Select } from "@interdependence-ui";
import { extendedSystemStylesProps } from "@mixins";
import { sort } from "utils/sort";
import { allGenderTypes } from "utils/genders";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox", "border"];
export default /*#__PURE__*/memo(function SelectGender(props) {
  var selected = props.selected,
    genders = props.genders,
    _onChange = props.onChange,
    allowBoth = props.allowBoth;
  var genderKeys = Object.keys(allGenderTypes);
  var total = [{
    id: "Total",
    label: allGenderTypes.Total
  }];
  var gendersTogether = genders.length >= 2 && allowBoth ? {
    id: "ManWoman",
    label: allGenderTypes.ManWoman
  } : [];
  var options = pipe(map(function (gender) {
    return {
      id: gender,
      label: allGenderTypes[gender]
    };
  }), function (x) {
    return total.concat(x).concat(gendersTogether);
  }, uniqBy(prop("id")))(genders);
  var sortedOptions = sort(function (option) {
    return genderKeys.indexOf(option.id);
  }, options);
  return /*#__PURE__*/_jsx(Select, _objectSpread({
    id: "select-gender",
    label: "V\xE4lj k\xF6n",
    hideLabel: true,
    selectedPrefix: /*#__PURE__*/_jsx("strong", {
      children: "K\xF6n:\xA0"
    }),
    _selected: sortedOptions.findIndex(function (option) {
      return equals(option.id, selected);
    }),
    options: sortedOptions,
    onChange: function onChange(idx) {
      return _onChange(sortedOptions[idx].id);
    }
  }, extendedSystemStylesProps(styledSystemKeys, props)));
}, function (prev, curr) {
  return equals(prev, curr);
});